document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    let filter = document.querySelector('div#algolia-shopify-instantsearch .ais-page .ais-facets');
    if(filter) {
      let btnFilter = document.querySelector('.ais-page .ais-facets-button');

      let label = document.querySelectorAll('div#algolia-shopify-instantsearch .ais-page .ais-facet--header');
      label.forEach(function(l,index){
        l.addEventListener('click', function(){
          this.classList.toggle('open');
        })
      });

    let close = document.createElement('div');
    let overlay = document.createElement('div');
    let container = document.querySelector('div#algolia-shopify-instantsearch .ais-page')
    overlay.innerHTML='<div class="filter-overlay"></div>'
    close.innerHTML='<p class="close-filter">&#x2715</p>';
    filter.appendChild(close);
    container.appendChild(overlay)
    document.addEventListener('click', function(e){
      if(e.target === btnFilter){
        filter.classList.toggle('active');
        document.querySelector('.filter-overlay').classList.toggle('active')
      }
      if(e.target.classList.contains('close-filter')) {
        btnFilter.click()
      
      }

      if(e.target.classList.contains('filter-overlay')) {
        btnFilter.click()
      }


    })
  }
   
  }, 1000);


})
